import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { ClipboardList } from "lucide-react";

export default function SuperAdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/superadmin/audit-logs?limit=200").then((r) => setLogs(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold">Journal d'audit</h1>
        <p className="text-sm text-slate-500">Actions administratives récentes</p>
      </div>
      <Card>
        <CardContent className="p-0 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-slate-500 border-b border-slate-200 dark:border-slate-800">
              <tr>
                <th className="text-left p-3">Date</th>
                <th className="text-left">Action</th>
                <th className="text-left">Acteur</th>
                <th className="text-left">Cible</th>
                <th className="text-left">Détails</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
              {logs.map((l) => (
                <tr key={l.id}>
                  <td className="p-3 text-xs whitespace-nowrap">{new Date(l.created_at).toLocaleString("fr-FR")}</td>
                  <td><span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-800 font-mono">{l.action}</span></td>
                  <td className="text-xs font-mono">{(l.actor_id || "").slice(0, 8)}…</td>
                  <td className="text-xs font-mono">{(l.target_id || "").slice(0, 8)}…</td>
                  <td className="text-xs text-slate-500">{JSON.stringify(l.payload)}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-slate-500"><ClipboardList className="w-8 h-8 mx-auto mb-2 opacity-40" /> Aucun log</td></tr>}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
